'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const differenceInDays = (start, end) => {
    const msPerDay = 24 * 60 * 60 * 1000;
    const utcStart = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());
    const utcEnd = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
    return Math.floor((utcEnd - utcStart) / msPerDay);
};

exports.differenceInDays = differenceInDays;
//# sourceMappingURL=difference-in-days.js.map
